

export const tripData = [
    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    },

    {
        booking_number:"689643875",
        trip_date:"Jan 20 11:16:am",
        customer_name:"Ram Kumar",
        phone_number:"9876743210",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"In-progress"
    }
];


export const tripColumns = [

    {
        name: 'BOOKING #',
        selector: row => row['booking_number'],
        sortable: true,
        center: true,
        // width:"130px",
        
    },
    {
        name: 'TRIP START DATE',
        selector: row => row['trip_date'],
        sortable: true,
        center: true,
        width:"170px",
        // maxWidth:"130px"
    },
    {
        name: 'PICKUP DATE AND TIME',
        selector: row => row['pickupBooking_time'],
        sortable: true,
        center: true,
        maxWidth:"190px",
    },
    {
        name: 'PICKUP',
        selector: row => row['pickup_location'],
        sortable: true,
        center: true,
        // maxWidth:"7vw",
    },
    {
        name: 'DROP',
        selector: row => row['drop_location'],
        sortable: true,
        center: true,
        // maxWidth:"7vw",
    },
   
    {
        name: 'CUSTOMER NAME',
        selector: row => row['customer_name'],
        sortable: true,
        center: true,
        width:"130px",
    },
    {
        name: 'PHONE #',
        selector: row => row['phone_number'],
        sortable: true,
        center: true,
        // width:"130px",
    },
    {
        name: 'STATUS',
        selector: row => row['status'],
        sortable: true,
        center: true,
        // width:"100px",
    }
];

export const carEVChargeColumns = [

    {
        name: 'ID',
        selector: row => row['id'],
        sortable: true,
        center: true,
        // width:"130px",
        
    },
    {
        name: 'BATTERY LEVEL',
        selector: row => row['batteryLevel'],
        sortable: true,
        center: true,
        width:"200px",
    },
    {
        name: 'ESTIMATED KM',
        selector: row => row['estimatedKm'],
        sortable: true,
        center: true,
        // maxWidth:"7vw",
    },
    {
        name: 'LAST UPDATED ON',
        selector: row => row['lastUpdatedOn'],
        sortable: true,
        center: true,
        // maxWidth:"7vw",
    },
];
